import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { eventNames } from '../config';

const Context = createContext();

const createEvtName = (name) => `${eventNames.modalDataChange}_${name}`;

export const ModalManagerProvider = ({ children, emmiterOptions }) => {
  const { notify, subscribe } = emmiterOptions;

  const stackRef = useRef(new Map());

  const getState = useCallback(
    (name) => stackRef.current.get(name) ?? { isOpen: false },
    []
  );

  const open = useCallback(
    (name, props) => {
      const data = { isOpen: true, props };
      stackRef.current.set(name, data);
      notify(createEvtName(name), data);
    },
    [notify]
  );

  const close = useCallback(
    (name) => {
      stackRef.current.delete(name);
      notify(createEvtName(name), { isOpen: false });
    },
    [notify]
  );

  const value = useMemo(
    () => ({ actions: { open, close }, getState, subscribe }),
    [open, close, getState, subscribe]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

const useModal = () => useContext(Context);

export const useModalState = (name) => {
  const { getState, subscribe } = useModal();

  const [state, setState] = useState(() => getState(name)); // { isOpen, props }

  useEffect(() => subscribe(createEvtName(name), setState), [name, subscribe]);

  return state;
};

export const useModalActions = () => {
  const { actions } = useModal();
  return actions;
};
